export type IconProps = {
  className?: string;
};

export function UrbanIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      role="img"
      aria-hidden="true"
      fill="currentColor"
    >
      <g>
        <g>
          <path
            d="M109.192,59.037H72.62c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449V69.486C119.641,63.715,114.963,59.037,109.192,59.037z M98.743,116.506H83.069V79.935h15.673
			V116.506z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.335,59.037h-36.571c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449V69.486C192.784,63.715,188.106,59.037,182.335,59.037z M171.886,116.506h-15.673V79.935
			h15.673V116.506z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M109.192,161.437H72.62c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C119.641,166.115,114.963,161.437,109.192,161.437z M98.743,218.906H83.069v-36.571
			h15.673V218.906z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.335,161.437h-36.571c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C192.784,166.115,188.106,161.437,182.335,161.437z M171.886,218.906h-15.673v-36.571
			h15.673V218.906z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M109.192,263.837H72.62c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C119.641,268.515,114.963,263.837,109.192,263.837z M98.743,321.306H83.069v-36.571
			h15.673V321.306z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.335,263.837h-36.571c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C192.784,268.515,188.106,263.837,182.335,263.837z M171.886,321.306h-15.673v-36.571
			h15.673V321.306z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M109.192,366.237H72.62c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C119.641,370.915,114.963,366.237,109.192,366.237z M98.743,423.706H83.069v-36.571
			h15.673V423.706z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M182.335,366.237h-36.571c-5.771,0-10.449,4.678-10.449,10.449v57.469c0,5.771,4.678,10.449,10.449,10.449h36.571
			c5.771,0,10.449-4.678,10.449-10.449v-57.469C192.784,370.915,188.106,366.237,182.335,366.237z M171.886,423.706h-15.673v-36.571
			h15.673V423.706z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,417.785h-0.137c-5.771,0-10.449,4.678-10.449,10.449c0,5.771,4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449C339.168,422.463,334.49,417.785,328.719,417.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,236.669h-0.137c-5.771,0-10.449,4.678-10.449,10.449c0,5.771,4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449C339.168,241.347,334.49,236.669,328.719,236.669z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,272.893h-0.137c-5.771,0-10.449,4.678-10.449,10.449c0,5.771,4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449C339.168,277.571,334.49,272.893,328.719,272.893z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,309.115h-0.137c-5.771,0-10.449,4.678-10.449,10.449c0,5.771,4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449C339.168,313.793,334.49,309.115,328.719,309.115z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,345.339h-0.137c-5.771,0-10.449,4.678-10.449,10.449c0,5.771,4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449C339.168,350.017,334.49,345.339,328.719,345.339z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M328.719,381.562h-0.137c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449h0.137
			c5.771,0,10.449-4.678,10.449-10.449S334.49,381.562,328.719,381.562z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M501.551,468.637h-8.359V126.955c0-5.771-4.678-10.449-10.449-10.449H357.355c-5.771,0-10.449,4.678-10.449,10.449v73.491
			H233.012V32.914c0-5.771-4.678-10.449-10.449-10.449H32.392c-5.771,0-10.449,4.678-10.449,10.449v435.722H10.449
			C4.678,468.637,0,473.315,0,479.086s4.678,10.449,10.449,10.449h472.294h18.808c5.771,0,10.449-4.678,10.449-10.449
			S507.322,468.637,501.551,468.637z M212.114,210.895v257.742H42.841V43.363h169.273V210.895z M346.906,468.637H233.012v-29.954
			h61.765c5.771,0,10.449-4.678,10.449-10.449c0-5.771-4.678-10.449-10.449-10.449h-61.765v-15.326h61.765
			c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449h-61.765v-15.324h61.765c5.771,0,10.449-4.678,10.449-10.449
			c0-5.771-4.678-10.449-10.449-10.449h-61.765v-15.326h61.765c5.771,0,10.449-4.678,10.449-10.449
			c0-5.771-4.678-10.449-10.449-10.449h-61.765V293.79h61.765c5.771,0,10.449-4.678,10.449-10.449s-4.678-10.449-10.449-10.449
			h-61.765v-15.325h61.765c5.771,0,10.449-4.678,10.449-10.449c0-5.771-4.678-10.449-10.449-10.449h-61.765v-15.326h113.894V468.637
			z M378.253,468.637h-10.449V210.895v-73.491h10.449V468.637z M409.6,468.637h-10.449V137.404H409.6V468.637z M440.947,468.637
			h-10.449V137.404h10.449V468.637z M472.294,468.637h-10.449V137.404h10.449V468.637z"
          />
        </g>
      </g>
    </svg>
  );
}
